// extracted by mini-css-extract-plugin
module.exports = {"checkTitleRow":"Canary_checkTitleRow__f1yoT"};